import { useEffect, useState } from "react";
import {
  connectWallet,
  getCurrentWalletConnected,
  ethapprove,
  ethdecline,
  pixaapprove,
  pixadecline,
  stakePixa,
  unstakePixa1,
  checkcurrentburnrate,
  checkcurrentrewardrate,
  executeBurn,
  executeReward,
  calculateCurrentRewards,
  checkSpecificRewards,
  checkcurrentpixavoteaddress,
  checkcurrentpixavotereason,
  checkcurrentpixavoteamount,
  checkcurrentpixavotestate,
  checkcurrentethvotestate,
  checkcurrentethvotereason,
  checkcurrentethvoteamount,
  checkcurrentethvoteaddress,
  checkcurrentpixatabs,
  checkcurrentpixavote,
  initiateBurn,
  initiateRewards,
  checktimetorewards,
  checktimetoburn,
  finalizeEth,
  finalizePixa,
  createEthVote,
  createPixaVote,
  claimNFTRewards
} from "./utils/interact.js";
import FrostBlade from 'D:/NFT_development/front_end/rewards-site/nft-minter-tutorial-main/minter-starter-files/src/pixarewardsupdated.png'

const Minter = (props) => {

  //State variables
  const [specificrewardcontract, setCheckSpecificRewardsContract] = useState("")
  const [specificrewardtokenid, setCheckSpecificRewardtknID] = useState("")
  const [specificrewardsavailable, setCheckSpecificRewards] = useState("");
  const [stakeLevel, setStakeLevel] = useState("");
  const [totalrewardsavailable, setchecktimetorewards] = useState("");
  const [rewardsaddress, setRewardsCheckAddress] = useState("");
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
  const [burnrate, setBurnRate] = useState("");
  const [rewardrate, setRewardRate] = useState(""); 
  const [ethtransfer, setethtransfer] = useState("");
  const [pixatransfer, setpixatransfer] = useState("");
  const [currentburnrate, setcurrentburnrate] = useState("");
  const [currentrewardrate, setcurrentrewardrate] = useState("");
  const [timetorewards, settimetorewards] = useState("");
  const [timetoburn, settimetoburn] = useState("");

  //pixa propose vote
  const [PixaReason, setPixaReason] = useState("");  
  const [PixaAmount, setPixaAmount] = useState("");
  const [PixaAddress, setPixaAddress] = useState("");

  //eth propose vote
  const [EthReason, setEthReason] = useState("");  
  const [EthAmount, setEthAmount] = useState("");
  const [EthAddress, setEthAddress] = useState("");

  //pixa voting
  const [currentpixavotestate, setpixavotestate] = useState("");  
  const [currentpixavotereason, setpixavotereason] = useState("");
  const [currentpixavoteamount, setpixavoteamount] = useState("");
  const [currentpixavoteaddress, setpixavoteaddress] = useState("");
  const [currentpixavotetabs, setpixavotetabs] = useState("");
  const [currentpixavotecount, setpixavote] = useState("");
  const [pixafinalize, setPixaFinalize] = useState("");

  //eth voting
  const [currentethvotestate, setethvotestate] = useState("");  
  const [currentethvotereason, setethvotereason] = useState("");
  const [currentethvoteamount, setethvoteamount] = useState("");
  const [currentethvoteaddress, setethvoteaddress] = useState("");
  const [currentethvotetabs, setethvotetabs] = useState("");
  const [currentethvotecount, setethvote] = useState("");
  const [ethfinalize, setEthFinalize] = useState("");


  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [url, setURL] = useState("");
 

  useEffect(async () => { //TODO: implement
    const {address, status} = await getCurrentWalletConnected();
    setWallet(address);
    setStatus(status);
    setBurnRate(10);
    setRewardRate(10);
    addWalletListener(); 
  }, []);

  const connectWalletPressed = async () => { //TODO: implement
    const walletResponse = await connectWallet();
    setStatus(walletResponse.status);
    setWallet(walletResponse.address);
    const { currentburnrate } = await checkcurrentburnrate();
    setcurrentburnrate(currentburnrate); 
    const { currentrewardrate } = await checkcurrentrewardrate();
    setcurrentrewardrate(currentrewardrate); 
    const { timetorewards} = await checktimetorewards();
    settimetorewards(timetorewards); 
    const { timetoburn} = await checktimetoburn();
    settimetoburn(timetoburn); 

    // pixa voting
    const { currentpixavotestate } = await checkcurrentpixavotestate();
    setpixavotestate(currentpixavotestate); 


    if (currentpixavotestate) {
    const { currentpixavotereason } = await checkcurrentpixavotereason();
    setpixavotereason(currentpixavotereason); 
    const { currentpixavoteamount } = await checkcurrentpixavoteamount();
    setpixavoteamount(currentpixavoteamount); 
    const { currentpixavoteaddress } = await checkcurrentpixavoteaddress();
    setpixavoteaddress(currentpixavoteaddress);
    const { currentpixavotecount } = await checkcurrentpixavote();
    setpixavote(currentpixavotecount); 
    const { currentpixavotetabs } = await checkcurrentpixatabs();
    setpixavotetabs(currentpixavotetabs); 

    } 
    else {
    setpixavotereason("No current vote"); 
    setpixavoteamount("-"); 
    setpixavoteaddress("-"); 
    setpixavotetabs("-");
    setpixavote("-");
    }
    // etj voting
    const { currentethvotestate } = await checkcurrentethvotestate();
    setethvotestate(currentethvotestate); 


    if (currentethvotestate) {
    const { currentethvotereason } = await checkcurrentethvotereason();
    setethvotereason(currentethvotereason); 
    const { currentethvoteamount } = await checkcurrentethvoteamount();
    setethvoteamount(currentethvoteamount); 
    const { currentethvoteaddress } = await checkcurrentethvoteaddress();
    setethvoteaddress(currentethvoteaddress);
    } 
    else {
    setethvotereason("No current vote"); 
    setethvoteamount("-"); 
    setethvoteaddress("-"); 
    setethvotetabs("-");
    setethvote("-");

    }
  };

  const onCalculateRewardsPressed = async () => { //TODO: implement
      setchecktimetorewards("Calculating please wait..."); 
      const {totalrewardsavailable, timeleft, amountstaked} = await calculateCurrentRewards(rewardsaddress);
      setchecktimetorewards([totalrewardsavailable, ' $PIXA claimable on ', timeleft, '. You have ', amountstaked, ' $PIXA staked.']);
  };


  

  const onCheckSpecificRewardspressed = async () => { //TODO: implement
      setCheckSpecificRewards("Calculating please wait...")
      const {specificrewardsavailable} = await checkSpecificRewards(specificrewardcontract,specificrewardtokenid);
      setCheckSpecificRewards(specificrewardsavailable)
  };

  const onBurnPressed = async () => { //TODO: implement
      executeBurn(burnrate);
  };

  const onRewardPressed = async () => { //TODO: implement
      executeReward(rewardrate);
  };

  const onEthVotePressed = async () => { //TODO: implement
      createEthVote(EthAddress, EthAmount, EthReason);
  };

  const onPixaVotePressed = async () => { //TODO: implement
      createPixaVote(PixaAddress, PixaAmount, PixaReason);
  };

  const onInitiateBurnPressed = async () => { //TODO: implement
      initiateBurn();
  };

  const onInitiateRewardsPressed = async () => { //TODO: implement
      initiateRewards();
  };



  const onClaimNFTRewardsPressed = async () => { //TODO: implement
      claimNFTRewards();
  };

  const onStakePixaPressed = async () => { //TODO: implement
      stakePixa(stakeLevel, walletAddress);
  };

  const onUnStakePixaPressed = async () => { //TODO: implement
      unstakePixa1();
  };
  //const onBurnPressed = async () => { //TODO: implement
   //   const { currentburnrate } = await executeburnrate(name);  
  //};

  //const onRewardPressed = async () => { //TODO: implement
  //    const { currentrewardrate } = await executerewardrate(name);  
  //};


  function addWalletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setWallet(accounts[0]);
          setStatus("");
        } else {
          setWallet("");
          setStatus("🦊 Connect to Metamask using the top right button.");
        }
      });
    } else {
      setStatus(
        <p>
          {" "}
          🦊{" "}
          <a target="_blank" href={`https://metamask.io/download.html`}>
            You must install Metamask, a virtual Ethereum wallet, in your
            browser.
          </a>
        </p>
      );
    }
  }

  return (
    <div className="Minter">


      <h1 id="title">$PIXA Rewards</h1>
      <h4 id="subheading">Disclaimer: PixaLyfe is not liable for your use of this interface, $PIXA, or it's NFT collections. We guarantee none of the information provided on this page is accurate, but we guarantee PixaLyfe intends it to be accurate. The PixaLyfe NFT ecosystem is based around collecting one-of-a-kind digital collectibles and interacting with them in unique ways. These are not investments, and we will never offer you financial advice. Prior to interacting with this site, read the terms and conditions you agree to by using PixaLyfe websites and platforms: pixalyfenft.com/terms (also can be found at the bottom of this page)</h4>   
      <button id="walletButton" onClick={connectWalletPressed}>
        {walletAddress.length > 0 ? (
          "Connected: " +
          String(walletAddress).substring(0, 6) +
          "..." +
          String(walletAddress).substring(38)
        ) : (
          <span>Connect Wallet</span>
        )}
      </button>
      <br></br>  
      <br></br>  
      <br></br>  
<h4> _________</h4>
      <br></br>  
      <br></br>  
      <br></br>        
      <h2 id= "pixarewardz">Claim $PIXA rewards! </h2>      
      <h4>You can only claim rewards if you own at least 1 PixaLyfe NFT. $PIXA is a utility token meant to interact with your PixaLyfe NFTs. $PIXA has no value. You can only claim once every 30 days. Once claimed, your NFTs 30 day clock is reset. </h4>     
      <button id="zeropercentwitchbutton" onClick={onClaimNFTRewardsPressed}>
        Claim Rewards!
      </button>      


      <h3  id="title"> Stake $PIXA. Enter a number from 1-4.</h3>
      <h5>1 = 50 $PIXA (2x multiplier) </h5>
      <h5>2 = 500 $PIXA (3x multiplier) </h5>
      <h5>3 = 5,000 PIXA (4x multiplier)</h5>
      <h5>4 = 50,000 $PIXA (5x multiplier) </h5>
      <h5>Staking requires 2 transactions: 1) to allow the contract to spend your $PIXA and 2) to actually stake $PIXA. The first transaction is only needed when first using the rewards system. Note: The staking mutliplier only applies to the first 1000 base value (BV) of your NFTs. </h5>    
                                  
      <input id="proposals"
          type="number"
          placeholder="level (1 - 4)"
          onChange={(event) => setStakeLevel(event.target.value)}
        />
      <br></br>  
      <button id="zeropercentwitchbutton" onClick={onStakePixaPressed}>
        Stake $PIXA
      </button>            

 
     <h5>Warning: When unstaking, you only receive 80% of your staked amount. 20% is donated to the rewards contract. You cannot withdraw part of your stake, it is all or nothing.    </h5>
          <br></br>  
         <button id="zeropercentwitchbutton" onClick={onUnStakePixaPressed}>
        Unstake $PIXA
      </button>   
          <br></br>  

      <h4> Check your rewards and current staked $PIXA. Enter the ethereum address you want to check: </h4>




      <input id="proposals"
          type="string"
          placeholder="address"
          onChange={(event) => setRewardsCheckAddress(event.target.value)}
        />
      <button id="ethfinalize" onClick={onCalculateRewardsPressed}>
        Check Rewards!
      </button> 
      <h4 id="subheading">Rewards: {totalrewardsavailable}</h4>      
   
      <div>
      <img src={FrostBlade} alt="Image" height={400} width={1200} class="center"/>
      </div>

<h4> _________</h4>
      <br></br>  
      <br></br>  
      <br></br>  

      <h5> Terms and Conditions (applies to all PixaLyfe sites): Your purchase of PixaLyfe NFTs does NOT CONSTITUTE AN INVESTMENT. Purchase of these NFTs from PixaLyfe is meant for entertainment purposes only. PixaLyfe makes no warranties regarding future value, express or implied, to the public or to buyers. Only purchase if you wish to own the artwork and nothing else. Only purchase with the current state of the project in mind and the assumption that no future value will be delivered. PixaLyfe NFTs and $PIXA tokens are not currency and do not convey ownership in PixaLyfe or its assets. You are purchasing a digital collectible, we do not guarantee any future development around these NFTs. $PIXA tokens are not shares or securities of any type. Holding a token does not entitle the holder to any ownership or other interest in PixaLyfe, future business operations, future revenue, or any control or ability to bind the entity. $PIXA tokens are merely a means by which you may be able to utilize certain services such as changing aspects of the artwork in your PixaLyfe NFT. There is no guarantee that the PixaVerse platform will actually be developed, although we guarantee that it is our intention to do so.</h5>
      <br></br>  
      <br></br>  
      <br></br>  

    </div>
  );
};

export default Minter;
